export const TOAST_AUTO_CLOSE_DURATION = 5000;

export const MATCHING_DOCUMENT_TOAST_ID = 'matching_document';
